import script from "./UserProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=e48735fa&lang=css"

const __exports__ = script;

export default __exports__